import _ from 'lodash';
import { ItemType } from '@/app/utils/constants/ItemType';
import defaultInvStrat from '@/app/utils/toolkit/defaults/defaultInvStrat';
import defaultInvStratReview from '@/app/utils/toolkit/defaults/defaultInvStratReview';
import defaultRentRelief from '@/app/utils/toolkit/defaults/defaultCovidRentRelief';
import { defaultPensionKitEstablishment } from '@/app/utils/toolkit/defaults/defaultPensionKitEstablishment';
import { defaultPensionKitPaymentInstruction } from '@/app/utils/toolkit/defaults/defaultPensionKitPaymentInstruction';

const itemTypes = [
  {
    type: ItemType.INVESTMENT_STRATEGY,
    default: _.cloneDeep(defaultInvStrat),
    route: 'inv-strat-investment-strategy',
    reviewPage: 4,
  },
  {
    type: ItemType.INVESTMENT_STRATEGY_REVIEW,
    default: _.cloneDeep(defaultInvStratReview),
    route: 'inv-strat-investment-strategy-review',
    reviewPage: 3,
  },
  {
    type: ItemType.RENT_RELIEF,
    default: _.cloneDeep(defaultRentRelief),
    route: 'covid-rent-relief',
    reviewPage: 3,
  },
  {
    type: ItemType.PENSION_ESTABLISHMENT,
    default: _.cloneDeep(defaultPensionKitEstablishment),
    route: 'pension-establishment-item',
    reviewPage: 3,
  },
  {
    type: ItemType.PENSION_PAYMENT_INSTRUCTION,
    default: _.cloneDeep(defaultPensionKitPaymentInstruction),
    route: 'pension-payment-instruction-item',
    reviewPage: 2,
  },
];

export function getItem(type) {
  return itemTypes.find(item => item.type === type);
}

export function getDefaultItem(type) {
  return itemTypes.find(item => item.type === type).default;
}

export function getLocalType(type) {
  let localType = type;
  if (type === 'COVID') {
    localType = ItemType.RENT_RELIEF;
  }
  return localType;
}

export default {
  getItem,
  getDefaultItem,
  getLocalType,
};
